import { Component } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment/moment";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import DisplayRenkoSlingData from "../components/Charts/DisplayRenkoData";
import ManualOrder from "../components/Charts/ManuallOrder";
import Operations from "../components/Charts/Operations";
import OrdersStatus from "../components/Charts/OrdersStatus";
import RealtimeStatus from "../components/Charts/RealtimeStatus";
import TradeApproach from "../components/Charts/TradeApproach";
import WalletConfig from "../components/Charts/WalletConfig";
import Spinner from "../components/common-components/Spinner";
import TradeBoxes from "../components/common-components/TradeBoxes";
import MainBoxHeader from "../components/MainBoxHeader";
import { getChartSettingsAction } from "../redux/actions/currenciesActions";
import { removeCookie } from "../utils/cookies";
import { errorToastify, successToastify } from "../utils/Toastify";
import { connectionClass } from "../websocket/socket";

class Charts extends Component {
    state = {
        isWalletEditable: false
    };
    shouldComponentUpdate(nextProps, nextState) {
        if (
            this.state.isWalletEditable !== nextState.isWalletEditable ||
            this.props.isDarkMode !== nextProps.isDarkMode ||
            this.props.currentCurrencyId !== nextProps.currentCurrencyId ||
            this.props.currentSide !== nextProps.currentSide ||
            this.props.spinnerStatus != nextProps.spinnerStatus
        ) {
            return true;
        }
        return false;
    }
    componentDidMount() {
        this.props.getChartSettingsAction();

        connectionClass.socketInfo.on("binanceRes", (res) => {
            if (res.positionSide == "LONG") {
                if (res.side == "BUY") {
                    successToastify(`A new ${res.symbol} position Entered`);
                }
                if (res.side == "SELL") {
                    successToastify(`Recent ${res.symbol} position Exited`);
                }
            }
            if (res.positionSide == "SHORT") {
                if (res.side == "SELL") {
                    successToastify(`A new ${res.symbol} position Entered`);
                }
                if (res.side == "BUY") {
                    successToastify(`Recent ${res.symbol} position Exited`);
                }
            }
        });
        connectionClass.socketInfo.on("binanceErr", (res) => {
            errorToastify(res);
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.currentCurrencyId != prevProps.currentCurrencyId) {
            this.props.getChartSettingsAction();
        }
    }

    render() {
        return (
            <div className="flex flex-col items-center   justify-center w-full xl:flex-row p-2">
                <div className="max-w-25 sm:max-w-none md:w-5/6 xl:w-1/6 h-full   flex-1 flex lg:flex-4 lg:justify-center">
                    <div className="lg:flex-4 max-w-25 md:max-w-none md:w-full flex flex-col   lg:max-w-5xl 2xl:max-w-11xl  ">
                        {this.props.spinnerStatus ? (
                            <Spinner
                                toggleValue={this.props.spinnerStatus}
                                props={{
                                    parentDiv: {
                                        style: { zIndex: 100 },
                                        className: "loader"
                                    },
                                    spinnerIcon: {
                                        style: {},
                                        className: "loader-icon"
                                    }
                                }}
                            />
                        ) : null}

                        <TradeBoxes
                            height="auto"
                            headerName={<MainBoxHeader name="AMIR" />}
                            classNames={{
                                parentDiv: `flex flex-col ${
                                    this.props.isDarkMode ? "bg-tertiaryDark " : "bg-tertiaryLight "
                                } rounded-2xl  md:max-w-none md:w-full xl:w-full `,
                                header: `flex w-full  h-1/2  secondaryBoder rounded-tl-2xl rounded-tr-2xl roundedt items-center p-2 ${
                                    this.props.isDarkMode
                                        ? "bg-secondaryDark "
                                        : "bg-secondaryLight "
                                }`,
                                content:
                                    "flex flex-col justify-center p-2 secondaryBoder rounded-bl-2xl rounded-br-2xl"
                            }}>
                            {/* <DisplayWaveData dataType="onlineData" /> */}
                            <DisplayRenkoSlingData dataType="onlineData" />
                        </TradeBoxes>
                        <RealtimeStatus />
                    </div>
                </div>
                <div className=" flex-1 flex flex-col px-2 mt-2 lg:mt-0 max-w-25 md:max-w-none md:w-5/6  secondaryBoder xl:w-1/6 xl:px-2 2xl:h-full 2xl:m-4">
                    <TradeApproach />
                    <WalletConfig
                        isWalletEditable={this.state.isWalletEditable}
                        setIsWalletEditable={(value) => this.setState({ isWalletEditable: value })}
                    />
                    <Operations isWalletEditable={this.state.isWalletEditable} />
                    {/* <ManualOrder /> */}
                    <OrdersStatus />
                </div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Charts</title>
                </Helmet>
                <ToastContainer />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getChartSettingsAction: () => dispatch(getChartSettingsAction())
    };
};

const mapStateToProps = (state) => {
    const persistedReducer = state.persistedReducer;
    const { currenciesList, currentSide, currentCurrencyId, spinnerStatus, isDarkMode } =
        persistedReducer;
    const currentCurrency = currenciesList[currentCurrencyId];

    return {
        currentSide,
        currentCurrencyId,
        currentCurrency,
        spinnerStatus,
        isDarkMode
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Charts);
